import React from 'react';

type AccountIconProps = {
  className: string;
};

const AccountIcon = (props: AccountIconProps) => (
  <svg
    className={props.className}
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fillRule='evenodd'>
      <path
        fillRule='nonzero'
        strokeWidth='2'
        d='M12 13c-2.425 0-4.597.786-6.206 2.167-1.565 1.344-2.588 3.249-2.795 5.507-.019.202.074 1.297.25 2.317 2.857.04 15.3.106 17.543-.206.135-.815.228-1.91.21-2.111-.208-2.259-1.231-4.164-2.796-5.507C16.597 13.785 14.426 13 12 13zm-.541-11c-1.033 0-1.966.432-2.642 1.126-.686.705-1.108 1.678-1.108 2.752 0 1.074.422 2.048 1.108 2.752.676.695 1.61 1.127 2.642 1.127 1.032 0 1.966-.432 2.642-1.127.686-.704 1.108-1.678 1.108-2.752 0-1.074-.422-2.047-1.108-2.752C13.425 2.432 12.491 2 11.46 2z'
      />
    </g>
  </svg>
);

export default AccountIcon;
